import { createContext } from 'react';
import { noop } from 'lodash-es';

export const SpuClassDirtyContext = createContext<{
  value: Record<string, boolean>;
  registerDirty: (id: string, dirty: boolean) => void;
  clearDirty: () => void;
  isDirty: boolean;
  wrapDirtyConfirm: (fn: (...arg: any[]) => void) => (...args: any[]) => void;
}>({
  value: {},
  registerDirty: noop,
  clearDirty: noop,
  isDirty: false,
  wrapDirtyConfirm: () => noop,
});
